import React, {
  ReactElement,
} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import {serviceReservationViewTable} from "../../../schema/serviceReservationViewTable";
import {FileField} from "./fields/FileField";

export const FileUploadDialog = ({
                              row,
                              onClose,

                            }: {
  onClose: () => void;
  row: any;
}): ReactElement => {

  return (
    <>
      <Dialog open={true} onClose={onClose}>
        <DialogTitle>Fájlok</DialogTitle>
        <DialogContent>

          <FileField
            allValue={{
              id: row?.service_reservation_id
            }}
            schema={serviceReservationViewTable}
            column={{
              columnName: 'files'
            }}
            isActive={true}
            onChange={()=>{

            }}
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Bezár</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
